module.exports = __webpack_public_path__ + "img/2.efd9e69c.png";